/**
 * @generated SignedSource<<444c998a8ab6303fdc7285a92892c882>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FontType = "BODY_BOLD" | "BODY_REGULAR" | "HEADING_BOLD" | "HEADING_REGULAR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InternBrandStyleTypography_brand$data = {
  readonly appConfig: {
    readonly buildTheme: {
      readonly fonts: ReadonlyArray<{
        readonly name: string;
        readonly type: FontType;
      }>;
      readonly id: string;
    };
    readonly id: string;
  };
  readonly id: string;
  readonly internStyle: {
    readonly fontFaces: ReadonlyArray<{
      readonly bold: {
        readonly fontFace: string;
        readonly fontWeight: number;
        readonly url: string;
      };
      readonly name: string;
      readonly regular: {
        readonly fontFace: string;
        readonly fontWeight: number;
        readonly url: string;
      };
    }>;
    readonly fonts: ReadonlyArray<string>;
  } | null;
  readonly " $fragmentType": "InternBrandStyleTypography_brand";
};
export type InternBrandStyleTypography_brand$key = {
  readonly " $data"?: InternBrandStyleTypography_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandStyleTypography_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fontWeight",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fontFace",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandStyleTypography_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "InternBrandStyle",
      "kind": "LinkedField",
      "name": "internStyle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fonts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternFontFamilyInfo",
          "kind": "LinkedField",
          "name": "fontFaces",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "InternFontWeightInfo",
              "kind": "LinkedField",
              "name": "bold",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "InternFontWeightInfo",
              "kind": "LinkedField",
              "name": "regular",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandAppConfigBuildThemeType",
          "kind": "LinkedField",
          "name": "buildTheme",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "BrandAppConfigBuildThemeFontType",
              "kind": "LinkedField",
              "name": "fonts",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "17a329837bd679cea48b511a17c28357";

export default node;
